import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useMediaPlanMetadataApi = () => {
  const { campaignId: mediaPlanId } = routeApi.useParams();

  return useQuery({
    ...MediaPlan.getMetadataQueryOptions({
      urlParams: {
        mediaPlanId,
      },
    }),
    staleTime: Infinity,
  });
};
